"use client";
import React, { useEffect } from "react";
import { GroupHeader } from "../../../ui/Headers";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import { newData } from ".";
import { EmblaCarouselType } from "embla-carousel";
import { ButtonControls } from "./Announcement";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { useGroupedServices } from "src/app/hooks/useGroupServices";

const OurServices = () => {
  const { data } = useFetchCompanyInfo();
  const filteredServices = React.useMemo(
    () =>
      newData.filter((service) =>
        data?.companyServices?.includes(service.assessor)
      ),
    []
  );

  if (data?.companyServices?.length === 0) {
    return null;
  }
  if (filteredServices.length === 0) {
    return null;
  }
  return (
    <section id="features" className="py-14 overflow-hidden">
      <div className="wrapper">
        <GroupHeader
          max={1024}
          subheader="We provide tailored solutions for property owners, tenants, and potential clients."
          header="Our Services"
        />
      </div>
      <SliderParent data={data?.companyServices} />
    </section>
  );
};
export default OurServices;

export interface Service {
  icon: React.JSX.Element;
  header: string;
  text: string;
  assessor: string;
}

export const Card: React.FC<Service> = ({ icon, header, text }) => {
  return (
    <div
      style={{ boxShadow: "0px 4px 50px 0px #2121210D" }}
      className="flex w-full gap-3 h-full rounded-2xl bg-white p-4"
    >
      <div className="h-[3.5rem] select-none bg-[rgba(var(--primary-color-rgb),0.1)] aspect-square flex items-center font-semibold justify-center rounded-lg">
        <span className="size-[4rem]  grid text-themeColor place-items-center">
          {icon}
        </span>
      </div>
      <div className="item">
        <h3 className="text-primary !font-semibold h5 mb-2">{header}</h3>
        <p className="text-grey-500 select-none">{text}</p>
      </div>
    </div>
  );
};

const Slider: React.FC<{
  direction: "rtl" | "ltr";
  data: Service[];
  emblaApiRef: (api: EmblaCarouselType) => void;
}> = ({ data, direction, emblaApiRef }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, direction, align: "start" },
    [AutoScroll({ playOnInit: false, speed: 2 })]
  );

  useEffect(() => {
    if (emblaApi) emblaApiRef(emblaApi);
  }, [emblaApi, emblaApiRef]);

  if (!data) {
    return <div>No service available</div>;
  }

  return (
    <div className="relative left-2" ref={emblaRef}>
      <div className={`flex ${direction === "rtl" && "flex-row-reverse"}`}>
        {data.map((item, index) => (
          <div
            key={index}
            className="transform-none basis-1/3 xlg:basis-1/2  sm:!basis-full min-w-0 h-auto shrink-0 pr-4"
          >
            <Card {...item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const SliderParent: React.FC<{ data?: string[]; variant?: boolean }> = ({
  data,
  variant,
}) => {
  const { slidersData, setEmblaApi, scrollPrev, scrollNext } =
    useGroupedServices(data, newData);
  return (
    <div className={`flex ${!variant && "wrapper"} overflow-hidden relative flex-col gap-14`}>
      <button
        onClick={scrollPrev}
        className={`absolute top-1/2 z-[50] cursor-pointer ${
          slidersData[0]?.length > 3 ? "block" : "hidden"
        } rotate-[180deg] left-0 transform -translate-y-1/2`}
      >
        <ButtonControls />
      </button>
      <button
        onClick={scrollNext}
        className={`absolute top-1/2 z-[50] right-0 transform -translate-y-1/2 ${
          slidersData[0]?.length > 3 ? "block" : "hidden"
        }`}
      >
        <ButtonControls />
      </button>
      {slidersData.map((sliderData, index) => (
        <Slider
          key={index}
          data={sliderData}
          direction="ltr"
          emblaApiRef={setEmblaApi(index)}
        />
      ))}
    </div>
  );
};
